import { render } from "./ClAlert.vue?vue&type=template&id=4c7c54d6&scoped=true"
import script from "./ClAlert.vue?vue&type=script&lang=js"
export * from "./ClAlert.vue?vue&type=script&lang=js"

import "./ClAlert.vue?vue&type=style&index=0&id=4c7c54d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7c54d6"]])

export default __exports__